function initFeaturedSlider(slider) {
  if (!slider) return;

  // Prevent double init
  if (slider.classList.contains('is-initialized')) return;
  slider.classList.add('is-initialized');

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 7,
    perMove: 1,
    gap: '16px',
    padding: { right: '100px' },
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1600: { perPage: 5 },
      1199: { perPage: 4 },
      1024: { perPage: 3 },
      768: {
        perPage: 2,
        padding: { right: '40px', left: '0px' }
      },
      575: {
        perPage: 1,
        padding: { right: '0px', left: '0px' }
      }
    },
  });

  splide.mount();
}

function autoInitSliders() {
  document.querySelectorAll('.fps-splide').forEach(initFeaturedSlider);
}

// Initial load
document.addEventListener('DOMContentLoaded', autoInitSliders);

// Shopify editor support
document.addEventListener('shopify:section:load', autoInitSliders);
